import React, { useEffect, useState } from "react";
import axios from "axios";

const COLORS = [
  "bg-blue-500",
  "bg-green-500",
  "bg-yellow-500",
  "bg-pink-500",
  "bg-purple-500",
  "bg-indigo-500",
  "bg-red-500",
];

const TopCountriesAnalytics = () => {
  var JSToken;
  var accessToken;
  if (localStorage.user) {
    JSToken = JSON.parse(localStorage.user);
    accessToken = JSToken.access_token;
  }
  const config = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${window.$domain}/api/method/get_top_countries_by_event_payments`, config)
      .then((res) => {
        const result = res.data.message;
        setData(result.top_countries || []);
        setTotal(result.total_event_payments || 0);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch country analytics", err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p className="text-gray-500">Loading Top Countries Analytics...</p>;
  }

  return (
    <div className="bg-white rounded-2xl shadow p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">
        🌍 Top Performing Countries by Event Payments
      </h2>

      <div className="space-y-3 max-h-[500px] overflow-y-auto pr-2">
        {data.map((item, index) => {
          const percent = ((item.count / total) * 100).toFixed(1);
          const barColor = COLORS[index % COLORS.length];

          return (
            <div key={index}>
              <div className="flex justify-between items-center mb-1">
                <span className="text-sm font-medium text-gray-700">
                  {item.country || "Unknown"}
                </span>
                <span className="text-sm text-gray-600">{item.count} ({percent}%)</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-3">
                <div
                  className={`h-3 rounded-full ${barColor}`}
                  style={{ width: `${percent}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopCountriesAnalytics;
